import PmsMainPage from './PmsMainPage';

export default PmsMainPage;